import { render, staticRenderFns } from "./Classes.vue?vue&type=template&id=45cebf76&scoped=true&lang=pug"
import script from "./Classes.vue?vue&type=script&lang=js"
export * from "./Classes.vue?vue&type=script&lang=js"
import style0 from "./Classes.vue?vue&type=style&index=0&id=45cebf76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cebf76",
  null
  
)

export default component.exports